<template>
  <v-container>
    <h1 class="text-center">💬 Chat-Sender-App</h1>
    <p class="text-center text-medium-emphasis">
      Zentrale Twitch-App, über die alle Bot-Instanzen Chat-Nachrichten senden
      (Send Chat Message API). Eine Änderung hier gilt für alle Instanzen,
      spätestens nach 5 Minuten Cache-Refresh im Bot - kein .env-Update nötig.
    </p>

    <v-card outlined class="pa-4 mb-6">
      <v-progress-linear v-if="loading" indeterminate class="mb-4"></v-progress-linear>
      <v-form v-else ref="form" v-model="formValid">
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field
              label="Client ID"
              v-model="clientId"
              :rules="[(v) => !!v || 'Pflichtfeld']"
              outlined
              dense
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field
              label="Client Secret"
              v-model="clientSecret"
              type="password"
              :rules="[(v) => !!v || 'Pflichtfeld']"
              outlined
              dense
            ></v-text-field>
          </v-col>
        </v-row>
        <p v-if="updatedAt" class="text-caption text-medium-emphasis">
          Zuletzt geändert: {{ new Date(updatedAt).toLocaleString('de-DE') }}
          <span v-if="updatedBy"> von {{ updatedBy }}</span>
        </p>
        <v-btn color="primary" :loading="saving" @click="save">Speichern</v-btn>
      </v-form>
    </v-card>

    <v-card outlined class="pa-4 mb-6">
      <v-card-title class="text-subtitle-1 font-weight-bold pl-0 pt-0">Bot-Consent</v-card-title>
      <p class="text-medium-emphasis">
        Nur einmalig nötig, wenn eine neue/andere Chat-Sender-App eingetragen wird (oder um den
        Refresh-Token für channel.chat.notification zu erneuern): Der Bot-Account muss dieser App
        gegenüber "user:bot" + "user:write:chat" + "user:read:chat" bestätigen.
        Vor dem Klick: Client ID/Secret oben speichern und in der Twitch-App als Redirect-URI
        <code>{{ backendCallbackUrl }}</code> hinterlegt haben. Im nächsten Schritt mit dem
        Bot-Account bei Twitch einloggen und bestätigen.
      </p>
      <v-btn
        color="secondary"
        :disabled="!clientId"
        :href="consentLink"
        target="_blank"
        rel="noopener"
      >
        Bot-Consent erneuern
      </v-btn>
    </v-card>

    <v-snackbar
      v-model="result.show"
      timeout="3000"
      :color="result.success ? 'green' : 'red'"
    >
      {{ result.message }}
    </v-snackbar>
  </v-container>
</template>

<script>

import BackendService from '@/services/BackendService';

export default {
  data() {
    return {
      formValid: false,
      loading: true,
      saving: false,
      clientId: '',
      clientSecret: '',
      updatedAt: null,
      updatedBy: null,
      result: {
        show: false,
        success: false,
        message: '',
      },
    };
  },
  computed: {
    backendCallbackUrl() {
      return `${process.env.VUE_APP_BACKENDSERVICE_BASEURL.replace(/\/+$/, '')}/chatSenderAuthCallback`;
    },
    consentLink() {
      return `https://id.twitch.tv/oauth2/authorize?client_id=${this.clientId}&redirect_uri=${encodeURIComponent(this.backendCallbackUrl)}&response_type=code&scope=user%3Abot%20user%3Awrite%3Achat%20user%3Aread%3Achat`;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      BackendService.getChatSenderConfig().then((data) => {
        const { config } = data.data;
        if (config) {
          this.clientId = config.client_id;
          this.clientSecret = config.client_secret;
          this.updatedAt = config.updated_at;
          this.updatedBy = config.updated_by;
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    save() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      BackendService.saveChatSenderConfig({
        client_id: this.clientId,
        client_secret: this.clientSecret,
      }).then(() => {
        this.result = { show: true, success: true, message: 'Gespeichert!' };
        this.load();
      }).catch(() => {
        this.result = { show: true, success: false, message: 'Speichern fehlgeschlagen.' };
      }).finally(() => {
        this.saving = false;
      });
    },
  },
};
</script>
